module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAO5JREFUeNpi/P//PwMpgAVEMDIywgUajv9X+P2fQYqJgeHzSzaGG7NMGH/D5ECGM4IJoIbKQ/9FWVgZSoDiWnDdjAzvGP4zTGu2ZDyJoqHxAAPHHw6GSUB7JLG44h/zP4bqBmvGKyC1TCCRP+wMHjgUgwDTP2aGODgHSuri8yjQYI20M/9Z4RqY/jMwEwgcRilOBka4hv+MDDfwqmZguN+gzfgLYQMDwzZgbHzE6aR/DMtR/NBowfiJhYWhDsh8gab2F9D9M5utGY/DbYPFAzjS9v9n+cvBYAy0TRrI/fTnD8PZDlvG9xgRRwoACDAAgCdWXAWH3GMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swiper/cir1.png
// module id = xWRg
// module chunks = 1